import { Suspense } from 'react';
import { CssBaseline } from '@mui/material';

import MuiThemeProvider from 'providers/MuiThemeProvider';
import ErrorBoundary from 'components/errors/ErrorBoundary';
import InitProvider from 'providers/InitProvider';
import AppInitiator from 'providers/AppInitiator';
import LauncherStrategyProvider from 'lib/launchStrategies/LauncherStrategyProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import NotificationsProvider from 'providers/NotificationsProvider';
import FaqVideoProvider from 'providers/FaqVideoProvider';
import AppContainer from 'components/appcontainer';
import NpsEligibility from 'components/nps/NpsEligibility';
import { Progress } from 'components/Progress';

const queryClient = new QueryClient();

const Views = () => {
  return (
    <ErrorBoundary>
      <CssBaseline />
      <NpsEligibility />
      <AppContainer />
    </ErrorBoundary>
  );
};

function Providers() {
  return (
    <MuiThemeProvider>
      <NotificationsProvider>
        <LauncherStrategyProvider>
          <FaqVideoProvider>
            <Views />
          </FaqVideoProvider>
        </LauncherStrategyProvider>
      </NotificationsProvider>
    </MuiThemeProvider>
  );
}

function App() {
  localStorage.setItem('Logout', 'false');
  return (
    <div className="App">
      <Suspense fallback={<Progress />}>
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <AppInitiator>
              <InitProvider>
                <Providers />
              </InitProvider>
            </AppInitiator>
          </QueryClientProvider>
        </ErrorBoundary>
      </Suspense>
    </div>
  );
}

export default App;
